module.exports = __webpack_public_path__ + "static/img/11.22a3d3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/11.png
// module id = hexf
// module chunks = 0